import Vue from "vue";
import Home from "../src/index.vue";
import "./registerServiceWorker";
import router from "./router";
import Axios from "axios";
import auth from './vue-axios'
import { store } from '../src/store';
require('../src/assets/css/app.css');
import VueImg from 'v-img';
Vue.use(VueImg);
import vueScrollBehavior from 'vue-scroll-behavior';
Vue.use(vueScrollBehavior, { router: router })
import Vuex from 'vuex'
Vue.use(Vuex)
Vue.config.productionTip = false;
Axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;
new Vue({
  render: h => h(Home),
  router,
  store,
  auth
}).$mount("#app");
